import { Badge, Tooltip } from '@cowbell/ui';

export const READ_ONLY_LABEL = 'Read-only';
export const READ_ONLY_TOOLTIP =
  'Created more than three months ago. Only a Cowbell admin can change it.';

export function ReadOnlyMarker() {
  return (
    <Tooltip label={READ_ONLY_TOOLTIP} withArrow>
      <Badge size="xs" color="gray" variant="light">
        {READ_ONLY_LABEL}
      </Badge>
    </Tooltip>
  );
}

export default ReadOnlyMarker;
